/**
 * PLATINUM PDP Kalkulator — Feeding calculator drawer
 * Uses real PLATINUM feeding guide tables from Pet Food Finder.
 * Volume discounts from PFF: DRY_QTY and WET_QTY tables.
 * v1.1 — March 2026
 */
(function() {
  'use strict';

  // ===== FEEDING TABLES (from PFF — official PLATINUM values) =====

  // Adult dry g/day — FG1: Chicken, Beef, Vet-Senior, Vet-Sensitive, Vet-Hypo
  var FG1 = [{w:1,d:30},{w:2,d:40},{w:3,d:55},{w:4,d:70},{w:5,d:85},{w:7.5,d:115},{w:10,d:150},{w:12.5,d:165},{w:15,d:190},{w:20,d:250},{w:25,d:300},{w:30,d:325},{w:40,d:425},{w:60,d:600},{w:80,d:750}];
  // Adult dry g/day — FG2: Iberico, Lamb, Vet-Light
  var FG2 = [{w:1,d:35},{w:2,d:45},{w:3,d:60},{w:4,d:75},{w:5,d:90},{w:7.5,d:120},{w:10,d:160},{w:12.5,d:175},{w:15,d:200},{w:20,d:260},{w:25,d:315},{w:30,d:340},{w:40,d:445},{w:60,d:630},{w:80,d:790}];

  // Adult wet-only g/day (same for both FG)
  var WET = [{w:1,d:46},{w:2,d:92},{w:3,d:138},{w:4,d:184},{w:5,d:185},{w:7.5,d:278},{w:10,d:310},{w:12.5,d:388},{w:15,d:465},{w:20,d:520},{w:25,d:650},{w:30,d:780},{w:40,d:880},{w:60,d:1320},{w:80,d:1760}];

  // Puppy dry g/day — indexed by adultWeight (string), then ageMonths (string)
  var PUPPY = {"1":{"2":25,"4":30,"6":40,"8":30,"10":30,"12":30},"2.5":{"2":50,"4":55,"6":60,"8":55,"10":55,"12":50},"3":{"2":55,"4":60,"6":75,"8":65,"10":65,"12":65},"5":{"2":85,"4":105,"6":110,"8":100,"10":95,"12":85},"7.5":{"2":115,"4":145,"6":150,"8":140,"10":135,"12":115},"10":{"2":130,"4":160,"6":175,"8":165,"10":160,"12":150},"12.5":{"2":145,"4":180,"6":195,"8":185,"10":180,"12":165},"15":{"2":160,"4":215,"6":220,"8":215,"10":215,"12":190},"20":{"2":205,"4":260,"6":275,"8":270,"10":270,"12":250},"25":{"2":235,"4":300,"6":320,"8":320,"10":320,"12":300},"30":{"2":270,"4":360,"6":370,"8":370,"10":365,"12":325},"40":{"2":320,"4":420,"6":440,"8":500,"10":455,"12":425},"60":{"2":370,"4":580,"6":605,"8":650,"10":630,"12":600},"80":{"2":410,"4":710,"6":750,"8":820,"10":810,"12":750}};

  // Puppy wet g/day
  var PUPPY_WET = {"1":{"2":35,"4":45,"6":58,"8":50,"10":50,"12":50},"2.5":{"2":88,"4":113,"6":145,"8":125,"10":125,"12":125},"3":{"2":105,"4":135,"6":174,"8":150,"10":150,"12":150},"5":{"2":175,"4":225,"6":290,"8":250,"10":250,"12":250},"7.5":{"2":263,"4":338,"6":435,"8":375,"10":375,"12":375},"10":{"2":200,"4":380,"6":420,"8":400,"10":400,"12":400},"12.5":{"2":250,"4":475,"6":525,"8":500,"10":500,"12":500},"15":{"2":300,"4":570,"6":630,"8":600,"10":600,"12":600},"20":{"2":340,"4":640,"6":680,"8":760,"10":680,"12":680},"25":{"2":425,"4":800,"6":850,"8":950,"10":850,"12":850},"30":{"2":510,"4":960,"6":1020,"8":1140,"10":1020,"12":1020},"40":{"2":520,"4":1000,"6":1160,"8":1280,"10":1360,"12":1200},"60":{"2":780,"4":1500,"6":1740,"8":1920,"10":2040,"12":1800},"80":{"2":1040,"4":2000,"6":2320,"8":2560,"10":2720,"12":2400}};

  // Known puppy weight breakpoints
  var PW = [1,2.5,3,5,7.5,10,12.5,15,20,25,30,40,60,80];

  // Activity multipliers (no "pro" for PDP kalkulator)
  var ACTIVITY = { low: 0.85, normal: 1.0, high: 1.2 };

  // ===== CAT FEEDING TABLES (from PFF cat-feeding-tables.json) =====
  // Kitten buckets by age: <=2mo, 3-4mo, 5-9mo, 10-12mo — indexed by current weight (kg)
  // Adult: indexed by current weight
  // Sterilised: min/max range at each weight
  var CAT_FEED = {
    chicken: {
      kitten: {
        '<=2':  [{w:0.5,g:40},{w:1,g:63},{w:1.5,g:83},{w:2,g:100}],
        '3-4':  [{w:1,g:50},{w:1.5,g:66},{w:2,g:80},{w:2.5,g:93},{w:3,g:105}],
        '5-9':  [{w:1.5,g:58},{w:2,g:70},{w:2.5,g:81},{w:3,g:92},{w:3.5,g:102},{w:4,g:112},{w:4.5,g:121},{w:5,g:130}],
        '10-12':[{w:2.5,g:70},{w:3,g:79},{w:3.5,g:88},{w:4,g:96},{w:4.5,g:104},{w:5,g:111},{w:5.5,g:119},{w:6,g:126}]
      },
      adult:      [{w:2,g:41},{w:3,g:54},{w:4,g:65},{w:5,g:76},{w:6,g:86},{w:7,g:95},{w:8,g:104}],
      sterilised: [{w:2,gMin:23,gMax:34},{w:3,gMin:30,gMax:44},{w:4,gMin:37,gMax:53},{w:5,gMin:42,gMax:62},{w:6,gMin:48,gMax:70},{w:7,gMin:53,gMax:78},{w:8,gMin:58,gMax:85}]
    },
    fish: {
      kitten: {
        '<=2':  [{w:0.5,g:41},{w:1,g:64},{w:1.5,g:85},{w:2,g:102}],
        '3-4':  [{w:1,g:51},{w:1.5,g:67},{w:2,g:82},{w:2.5,g:95},{w:3,g:107}],
        '5-9':  [{w:1.5,g:59},{w:2,g:71},{w:2.5,g:83},{w:3,g:94},{w:3.5,g:104},{w:4,g:114},{w:4.5,g:123},{w:5,g:133}],
        '10-12':[{w:2.5,g:71},{w:3,g:81},{w:3.5,g:90},{w:4,g:98},{w:4.5,g:106},{w:5,g:113},{w:5.5,g:121},{w:6,g:129}]
      },
      adult:      [{w:2,g:42},{w:3,g:55},{w:4,g:66},{w:5,g:78},{w:6,g:88},{w:7,g:97},{w:8,g:106}],
      sterilised: [{w:2,gMin:23,gMax:34},{w:3,gMin:30,gMax:44},{w:4,gMin:37,gMax:53},{w:5,gMin:42,gMax:62},{w:6,gMin:48,gMax:70},{w:7,gMin:53,gMax:78},{w:8,gMin:58,gMax:85}]
    }
  };

  // Cat lifestyle multipliers (from PFF)
  var LIFESTYLE = { 'indoor': 0.90, 'indoor-active': 1.00, 'outdoor': 1.15 };

  // ===== VOLUME DISCOUNT TABLES (from PFF) =====
  // q = quantity, d = discount (0.11 = 11% off)
  var DRY_QTY = [{q:1,d:0},{q:2,d:0.11},{q:3,d:0.20},{q:4,d:0.23},{q:6,d:0.28}];
  var WET_QTY = [{q:1,d:0},{q:2,d:0.04},{q:3,d:0.06},{q:4,d:0.08},{q:6,d:0.10}];
  var CAT_QTY = [{q:1,d:0},{q:2,d:0.04},{q:3,d:0.07},{q:4,d:0.10},{q:6,d:0.12}];

  // ===== INTERPOLATION (from PFF) =====
  // Dog tables use .d as g/day value (legacy naming). Cat tables use .g.
  function interp(table, w, field) {
    field = field || 'd';
    if (w <= table[0].w) return table[0][field];
    if (w >= table[table.length - 1].w) return table[table.length - 1][field];
    for (var i = 0; i < table.length - 1; i++) {
      if (w >= table[i].w && w <= table[i + 1].w) {
        var r = (w - table[i].w) / (table[i + 1].w - table[i].w);
        return Math.round(table[i][field] + r * (table[i + 1][field] - table[i][field]));
      }
    }
    return table[0][field];
  }

  // Cat kitten age bucket from anchor month (2/4/7/11 → <=2/3-4/5-9/10-12)
  function catKittenBucket(ageMonths) {
    if (ageMonths <= 2) return '<=2';
    if (ageMonths <= 4) return '3-4';
    if (ageMonths <= 9) return '5-9';
    return '10-12';
  }

  function roundTo2_5(g) { return Math.round(g / 2.5) * 2.5; }

  function nearest(val, arr) {
    var best = arr[0], bd = Math.abs(val - best);
    for (var i = 0; i < arr.length; i++) {
      var d = Math.abs(val - arr[i]);
      if (d < bd) { bd = d; best = arr[i]; }
    }
    return best;
  }

  function roundTo5(g) { return Math.ceil(g / 5) * 5; }

  // ===== EUR FORMAT =====
  function fmtEur(n) { return n.toFixed(2).replace('.', ',') + ' €'; }

  // ===== MAIN CALCULATOR =====
  var el = document.getElementById('platinum-kalk');
  if (!el) return;

  var species = el.dataset.species || 'dog';      // 'dog' or 'cat'
  var foodType = el.dataset.foodType;             // 'dry' or 'wet'
  var feedingGroup = parseInt(el.dataset.feedingGroup) || 1;
  var isPuppy = el.dataset.isPuppy === 'true';
  var isCat = (species === 'cat');
  var catLifeStage = el.dataset.catLifeStage || ''; // 'kitten' | 'sterilised' | 'adult'
  var catFlavor = el.dataset.catFlavor || 'chicken';
  var isKitten = (isCat && catLifeStage === 'kitten');
  var isWetFood = (foodType === 'wet');
  var qtyTable = isCat ? CAT_QTY : (isWetFood ? WET_QTY : DRY_QTY);
  var variants = [];

  // Parse variant data from Liquid JSON
  try {
    variants = JSON.parse(document.getElementById('platinum-kalk-variants').textContent);
  } catch (e) {
    console.warn('[PLATINUM Kalkulator] Could not parse variant data');
  }

  // Parse variant weights into grams for comparison table
  // For wet food (MENU): variants are "375g / 12 kosov", "375g / 1 kos", etc.
  // We only want 12-pack variants for wet food.
  var variantSizes = [];
  var seenGrams = {};

  variants.forEach(function(v) {
    var grams = 0;
    var label = v.title;

    // For wet food: skip "1 kos" variants, keep only "12 kosov"
    if (isWetFood) {
      if (label.indexOf('1 kos') !== -1 && label.indexOf('12') === -1) return;
    }

    // Parse weight from title (e.g. "5 kg", "1.5 kg", "900 g (Mini)", "375g / 12 kosov")
    var kgMatch = label.match(/([\d.]+)\s*kg/i);
    var gMatch = label.match(/([\d.]+)\s*g/i);
    if (kgMatch) {
      grams = parseFloat(kgMatch[1]) * 1000;
    } else if (gMatch) {
      grams = parseFloat(gMatch[1]);
    } else if (v.weight > 0) {
      grams = v.weight_unit === 'kg' ? v.weight * 1000 : v.weight;
    }

    // Deduplicate by grams (wet food may have multiple variants with same grams)
    if (grams > 0 && !seenGrams[grams]) {
      seenGrams[grams] = true;
      var displayTitle = label;
      if (isWetFood) {
        displayTitle = grams + 'g';
      }
      variantSizes.push({
        id: v.id,
        title: displayTitle,
        price: v.price,       // For dry: price per bag. For wet: price per 12-pack.
        grams: grams,          // Per single unit (bag or single tetrapak)
        available: v.available
      });
    }
  });

  // Sort by grams ascending
  variantSizes.sort(function(a, b) { return a.grams - b.grams; });

  // ===== STATE =====
  var state = {
    weight: isCat ? (isKitten ? 2 : 4) : 15,
    activity: isCat ? 'indoor-active' : 'normal',
    ageMonths: isCat ? (isKitten ? 4 : 5) : 5
  };

  // ===== DOM REFS =====
  var weightInput = document.getElementById('kalk-weight');
  var activityPills = document.getElementById('kalk-activity-pills');
  var agePills = document.getElementById('kalk-age-pills');
  var resultsIntro = document.getElementById('kalk-results-intro');
  var dailyGEl = document.getElementById('kalk-daily-g');
  var recLabelEl = document.getElementById('kalk-rec-label');
  var recEurEl = document.getElementById('kalk-rec-eur');
  var bestSubEl = document.getElementById('kalk-best-sub');
  var perSizeEl = document.getElementById('kalk-per-size');
  var cardTable = document.getElementById('kalk-card-table');

  // ===== CALCULATE DAILY GRAMS =====
  function calcDailyGrams() {
    var w = state.weight;

    // CAT branch
    if (isCat) {
      var catTable = CAT_FEED[catFlavor] || CAT_FEED.chicken;
      var lifeMul = LIFESTYLE[state.activity] || 1.0;

      if (catLifeStage === 'kitten') {
        var bucket = catKittenBucket(state.ageMonths);
        var kRows = catTable.kitten[bucket] || catTable.kitten['5-9'];
        var baseG = interp(kRows, w, 'g');
        // Kittens: no lifestyle multiplier (growth priority — per PFF)
        return roundTo2_5(baseG);
      }

      if (catLifeStage === 'sterilised') {
        var sRows = catTable.sterilised;
        var gMin = interp(sRows, w, 'gMin');
        var gMax = interp(sRows, w, 'gMax');
        var avgG = (gMin + gMax) / 2;
        var sterG = roundTo2_5(avgG * lifeMul);
        var floorG = roundTo2_5(gMin);
        return sterG < floorG ? floorG : sterG;
      }

      // Adult cat
      var aRows = catTable.adult;
      var adultG = interp(aRows, w, 'g');
      return roundTo2_5(adultG * lifeMul);
    }

    if (isPuppy) {
      var feedTable = isWetFood ? PUPPY_WET : PUPPY;
      var aw = nearest(w, PW);
      var age = state.ageMonths;
      var nearestAge = nearest(age, [2, 4, 6, 8, 10, 12]);
      var k = String(aw);
      var mk = String(nearestAge);

      // Age 5 months: interpolate between 4 and 6 (not in table)
      if (age === 5 && feedTable[k]) {
        var g4 = feedTable[k]['4'] || 0;
        var g6 = feedTable[k]['6'] || 0;
        return roundTo5(Math.round((g4 + g6) / 2));
      }

      return roundTo5((feedTable[k] && feedTable[k][mk]) || 150);
    }

    // Adult — activity multiplier applied
    var actMul = ACTIVITY[state.activity] || 1.0;
    var table = isWetFood ? WET : (feedingGroup === 2 ? FG2 : FG1);
    var gpd = interp(table, w);
    return roundTo5(Math.round(gpd * actMul));
  }

  // ===== GET DEFAULT SIZE INDEX =====
  // Find the best matching variant index based on weight and PFF rules.
  function getDefaultSizeIdx() {
    if (variantSizes.length === 0) return 0;
    var w = state.weight;
    var targetG;

    if (isCat) {
      // Cat dry: ≤3kg → 400g, ≤5kg → 1500g, else 3000g
      targetG = w <= 3 ? 400 : w <= 5 ? 1500 : 3000;
    } else if (isWetFood) {
      // Wet: ≤3kg → 90g, 4-9kg → 185g, 10+kg → 375g
      targetG = w <= 3 ? 90 : w <= 9 ? 185 : 375;
    } else {
      // Dry dog: ≤6kg → 900g, 7-11kg → 1500g, 12+kg → 5000g
      targetG = w <= 6 ? 900 : w <= 11 ? 1500 : 5000;
    }

    // Find closest variant by grams
    var bestIdx = 0;
    var bestDiff = Math.abs(variantSizes[0].grams - targetG);
    for (var i = 1; i < variantSizes.length; i++) {
      var diff = Math.abs(variantSizes[i].grams - targetG);
      if (diff < bestDiff) {
        bestDiff = diff;
        bestIdx = i;
      }
    }
    return bestIdx;
  }

  // ===== COST CALCULATION (same as PFF) =====
  // Dry: cpd = (basePrice × qty × (1 - discount)) / (packGrams × qty) × dailyG
  //      simplified: cpd = (basePrice / packGrams) × dailyG × (1 - discount)
  // Wet: cpd = (p12 × qty × (1 - discount)) / (grams × 12 × qty) × dailyG
  //      simplified: cpd = (p12 / (grams × 12)) × dailyG × (1 - discount)
  function calcCpd(variant, dailyG, discount) {
    var d = discount || 0;
    if (isWetFood) {
      // variant.price = price per 12-pack, variant.grams = per single unit
      return (variant.price / (variant.grams * 12)) * dailyG * (1 - d);
    } else {
      // variant.price = price per bag, variant.grams = bag grams
      return (variant.price / variant.grams) * dailyG * (1 - d);
    }
  }

  function calcTotal(variant, qty, discount) {
    return Math.round(variant.price * qty * (1 - discount) * 100) / 100;
  }

  function calcDays(variant, qty, dailyG) {
    if (dailyG <= 0) return 0;
    if (isWetFood) {
      return Math.round((variant.grams * 12 * qty) / dailyG);
    } else {
      return Math.round((variant.grams * qty) / dailyG);
    }
  }

  // ===== UPDATE DISPLAY =====
  var debounceTimer = null;

  function update() {
    var dailyG = calcDailyGrams();
    var defaultIdx = getDefaultSizeIdx();
    if (defaultIdx >= variantSizes.length) defaultIdx = variantSizes.length - 1;
    if (defaultIdx < 0) defaultIdx = 0;

    var defaultVariant = variantSizes[defaultIdx];
    if (!defaultVariant) return;

    // Best €/dan = recommended size at max volume discount
    var maxDiscount = qtyTable[qtyTable.length - 1].d;
    var bestCpd = Math.round(calcCpd(defaultVariant, dailyG, maxDiscount) * 100) / 100;

    // Intro text
    if (isCat) {
      if (isKitten) {
        var ageLbl = { 2: 'do 2 mes.', 4: '3–4 mes.', 7: '5–9 mes.', 11: '10–12 mes.' };
        resultsIntro.textContent = 'Tvoj mladiček (' + state.weight + ' kg, ' + (ageLbl[state.ageMonths] || '3–4 mes.') + ') potrebuje:';
      } else {
        // PFF labels: indoor=domača mačka, indoor-active=aktivna doma, outdoor=hodi ven
        var lsLbl = { 'indoor': 'domača', 'indoor-active': 'aktivna doma', 'outdoor': 'hodi ven' };
        var stageLbl = catLifeStage === 'sterilised' ? 'sterilizirana' : 'odrasla';
        resultsIntro.textContent = 'Tvoja ' + stageLbl + ' mačka (' + state.weight + ' kg, ' + (lsLbl[state.activity] || 'aktivna doma') + ') potrebuje:';
      }
    } else if (isPuppy) {
      resultsIntro.textContent = 'Tvoj mladič (' + state.weight + ' kg odrasla teža, ' + state.ageMonths + ' mes.) potrebuje:';
    } else {
      var actLabel = { low: 'malo aktiven', normal: 'normalno aktiven', high: 'zelo aktiven' };
      resultsIntro.textContent = 'Tvoj pes (' + state.weight + ' kg, ' + (actLabel[state.activity] || 'normalno aktiven') + ') potrebuje:';
    }

    // Result values
    var recCpd = Math.round(calcCpd(defaultVariant, dailyG, 0) * 100) / 100;
    var maxQty = qtyTable[qtyTable.length - 1].q;

    // Labels: wet = "12× 375g", dry = "5 kg"
    var recLabel, bestLabel;
    if (isWetFood) {
      recLabel = '12× ' + defaultVariant.title;
      bestLabel = (maxQty * 12) + '× ' + defaultVariant.title;
    } else {
      recLabel = '1× ' + defaultVariant.title;
      bestLabel = maxQty + '× ' + defaultVariant.title;
    }

    dailyGEl.textContent = dailyG + ' g / dan';
    recLabelEl.textContent = recLabel;
    recEurEl.textContent = fmtEur(recCpd) + ' / dan';
    bestSubEl.textContent = 'Že od ' + fmtEur(bestCpd) + '/dan pri ' + bestLabel;

    // Per-size €/dan breakdown
    var sizeHtml = '';
    variantSizes.forEach(function(v) {
      var cpd1x = Math.round(calcCpd(v, dailyG, 0) * 100) / 100;
      var sizeLabel = isWetFood ? '12× ' + v.title : v.title;
      sizeHtml += '<div class="platinum-kalk__result-row">';
      sizeHtml += '<span class="platinum-kalk__result-label">' + sizeLabel + '</span>';
      sizeHtml += '<span class="platinum-kalk__result-value">' + fmtEur(cpd1x) + ' / dan</span>';
      sizeHtml += '</div>';
    });
    perSizeEl.innerHTML = sizeHtml;

    // Comparison table
    buildComparisonTable(dailyG, defaultIdx);
  }

  // ===== UNIFIED TABLE =====
  // One card-style table: all sizes at 1× + volume tiers for recommended size
  function buildComparisonTable(dailyG, recommendedIdx) {
    if (!cardTable || variantSizes.length === 0) return;

    var html = '';
    var recVariant = variantSizes[recommendedIdx];

    // Card wrapper — 3 columns
    html += '<table class="platinum-kalk__table">';
    html += '<thead><tr><th>Pakiranje</th><th>Traja</th><th>€/dan</th></tr></thead>';
    html += '<tbody>';

    // All sizes at 1×
    variantSizes.forEach(function(v, idx) {
      var isRec = (idx === recommendedIdx);
      var cpd = Math.round(calcCpd(v, dailyG, 0) * 100) / 100;
      var days = calcDays(v, 1, dailyG);
      var cellLabel = isWetFood ? '12× ' + v.title : '1× ' + v.title;
      var rowClass = isRec ? 'platinum-kalk__row--recommended' : '';

      html += '<tr' + (rowClass ? ' class="' + rowClass + '"' : '') + '>';
      html += '<td>' + (isRec ? '<strong>' + cellLabel + '</strong> <span class="platinum-kalk__badge">Priporočamo</span>' : cellLabel) + '</td>';
      html += '<td>' + days + ' dni</td>';
      html += '<td>' + (isRec ? '<strong>' + fmtEur(cpd) + '</strong>' : fmtEur(cpd)) + '</td>';
      html += '</tr>';
    });

    // Volume tiers for recommended size (skip qty=1, already shown)
    if (recVariant) {
      html += '<tr class="platinum-kalk__row--vol-header"><td colspan="3"><span class="platinum-kalk__vol-label">Več kupiš – več prihraniš</span></td></tr>';

      for (var i = 1; i < qtyTable.length; i++) {
        var tier = qtyTable[i];
        var cpd = Math.round(calcCpd(recVariant, dailyG, tier.d) * 100) / 100;
        var days = calcDays(recVariant, tier.q, dailyG);

        var tierLabel;
        if (isWetFood) {
          tierLabel = (tier.q * 12) + '× ' + recVariant.title;
        } else {
          tierLabel = tier.q + '× ' + recVariant.title;
        }

        html += '<tr class="platinum-kalk__row--volume">';
        html += '<td>' + tierLabel + '</td>';
        html += '<td>' + days + ' dni</td>';
        html += '<td><strong>' + fmtEur(cpd) + '</strong></td>';
        html += '</tr>';
      }
    }

    html += '</tbody></table>';
    cardTable.innerHTML = html;
  }

  // ===== EVENT HANDLERS =====

  // Weight input — cat uses stepper (PFF pattern), dog uses debounced number input
  var CAT_MIN_W = isKitten ? 0.5 : 1;
  var CAT_MAX_W = isKitten ? 8 : 10;
  var CAT_STEP = 0.5;
  var warnEl = document.getElementById('kalk-weight-warn');

  function showWarn(msg) {
    if (!warnEl) return;
    if (msg) { warnEl.textContent = msg; warnEl.style.display = ''; }
    else { warnEl.style.display = 'none'; }
  }

  if (weightInput && isCat) {
    // Strip invalid chars, comma→dot, max 1 decimal point. Do NOT clamp while typing.
    weightInput.addEventListener('input', function() {
      var raw = weightInput.value.replace(',', '.').replace(/[^0-9.]/g, '');
      var parts = raw.split('.');
      if (parts.length > 2) raw = parts[0] + '.' + parts[1];
      if (raw !== weightInput.value) weightInput.value = raw;

      var val = parseFloat(raw);
      if (!isNaN(val) && val >= CAT_MIN_W && val <= CAT_MAX_W) {
        state.weight = val;
        showWarn('');
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(update, 200);
      } else if (!isNaN(val)) {
        showWarn('Vnesi težo med ' + CAT_MIN_W + ' in ' + CAT_MAX_W + ' kg.');
      }
    });

    // Clamp on blur
    weightInput.addEventListener('blur', function() {
      var val = parseFloat(weightInput.value.replace(',', '.'));
      if (isNaN(val)) val = isKitten ? 2 : 4;
      if (val < CAT_MIN_W) val = CAT_MIN_W;
      if (val > CAT_MAX_W) val = CAT_MAX_W;
      val = Math.round(val * 10) / 10;
      weightInput.value = String(val).replace('.', ',');
      state.weight = val;
      showWarn('');
      update();
    });

    // +/− stepper buttons (step 0.5)
    function stepWeight(delta) {
      var cur = state.weight || (isKitten ? 2 : 4);
      var next = Math.round((cur + delta) * 10) / 10;
      if (next < CAT_MIN_W) next = CAT_MIN_W;
      if (next > CAT_MAX_W) next = CAT_MAX_W;
      weightInput.value = String(next).replace('.', ',');
      state.weight = next;
      showWarn('');
      update();
    }
    var btnMinus = document.getElementById('kalk-weight-minus');
    var btnPlus = document.getElementById('kalk-weight-plus');
    if (btnMinus) btnMinus.addEventListener('click', function() { stepWeight(-CAT_STEP); });
    if (btnPlus)  btnPlus.addEventListener('click',  function() { stepWeight(+CAT_STEP); });

    // Init display with comma
    weightInput.value = String(state.weight).replace('.', ',');

  } else if (weightInput) {
    // Dog — unchanged behavior (integer, debounced)
    weightInput.addEventListener('input', function() {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function() {
        var val = parseInt(weightInput.value) || 15;
        val = Math.max(1, Math.min(80, val));
        state.weight = val;
        update();
      }, 300);
    });
  }

  // Activity pills (adult)
  if (activityPills) {
    activityPills.addEventListener('click', function(e) {
      var pill = e.target.closest('.platinum-kalk__pill');
      if (!pill) return;

      activityPills.querySelectorAll('.platinum-kalk__pill').forEach(function(p) {
        p.classList.remove('platinum-kalk__pill--active');
      });
      pill.classList.add('platinum-kalk__pill--active');

      state.activity = pill.dataset.value;
      update();
    });
  }

  // Age pills (puppy)
  if (agePills) {
    agePills.addEventListener('click', function(e) {
      var pill = e.target.closest('.platinum-kalk__pill');
      if (!pill) return;

      agePills.querySelectorAll('.platinum-kalk__pill').forEach(function(p) {
        p.classList.remove('platinum-kalk__pill--active');
      });
      pill.classList.add('platinum-kalk__pill--active');

      state.ageMonths = parseInt(pill.dataset.value) || 5;
      update();
    });
  }

  // Drawer opening is handled natively by Prestige theme via aria-controls.
  // Close button at bottom of drawer:
  var closeBtn = document.getElementById('kalk-close-btn');
  if (closeBtn) {
    closeBtn.addEventListener('click', function() {
      var drawer = document.getElementById('platinum-kalkulator-drawer');
      if (drawer && drawer.hide) drawer.hide();
    });
  }

  // Initial calculation
  update();
})();
